module.exports = __webpack_public_path__ + "img/clickLine.a61a830b.svg";